import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";

/**
 * 抄送配置
 */
export class CarbonCopyConfigApi1 extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'carbon-copy-config'
    }




}
